let currentView = 'list';

// Handle dropdown click
const toggles = document.querySelectorAll('.brands__toggle-item');
toggles.forEach(toggle => {
  toggle.addEventListener('click', event => {
    const dropdown = document.querySelector('.brands__toggle-dropdown');
    const list = document.querySelector('.brands__list');
    const grid = document.querySelector('.brands__grid');
    const letters = document.querySelector('.brands-header__letters-wrapper');

    if (toggle.classList.contains('active')) {
      dropdown.classList.toggle('active');
    } else {
      document.querySelector('.brands__toggle-item.active').classList.remove('active');
      toggle.classList.add('active');
      dropdown.classList.remove('active');

      if (toggle.dataset.toggle == 'list') {
        grid.classList.remove('active');
        list.classList.add('active');
        letters.classList.remove('active');

        currentView = 'list';
      } else if (toggle.dataset.toggle == 'grid') {
        list.classList.remove('active');
        grid.classList.add('active');
        letters.classList.add('active');

        currentView = 'grid';
      }
    }
  });
});

// Letter click
const letterButtons = document.querySelectorAll('.brands-header__letter');
letterButtons.forEach(letterButton => {
  letterButton.addEventListener('click', event => {
    event.preventDefault();
    const letter = letterButton.dataset.letter;

    if (currentView == 'list') {
      let fromTop = document.querySelector(`.brands__list-item[data-letter="${letter}"]`).getBoundingClientRect().top - document.querySelector('.outer-header-wrapper').offsetHeight - 30;
      window.scrollTo({
        top: fromTop,
        behavior: 'smooth'
      });
    } else if (currentView == 'grid') {
      let fromTop = document.querySelector(`.brands__grid-item[data-letter="${letter}"]`).getBoundingClientRect().top - document.querySelector('.outer-header-wrapper').offsetHeight - 30;
      window.scrollTo({
        top: fromTop,
        behavior: 'smooth'
      });
    }
  });
});